export interface ISelectItem {
    field?: string, 
    alias?: string,
    func?: string
}